// extracted by mini-css-extract-plugin
export default {"InfinityGridContainer":"InfinityGrid_InfinityGridContainer__u8LAH"};